import {observer} from "mobx-react";
import styled from "styled-components";
import type {AppState} from "../data/state/AppState";
import {Functions} from "../utils/function/Functions";
import {DomPortal} from "./modules/abstract/portal/DomPortal";
import {PopupBackdropV5} from "./5.0/popup/PopupBackdropV5";
import {LoginWindowV5} from "./5.0/login/LoginWindowV5";
import {LoginWindowStyled} from "./5.0/user/UserStaticV5.Style";
import {LoginWindow} from "./windows/login/LoginWindow";

interface ILoginPopupProps {
	appState: AppState;
	isVisible: boolean;
	onClose: () => void;
	handleSwitchFromSSOToNormalLoginSuccess: () => void;
}

export const LoginPopup = observer((props: ILoginPopupProps) => {
	const {appState, isVisible, onClose, handleSwitchFromSSOToNormalLoginSuccess} = props;

	if (isVisible) {
		const {currentUIVersion} = appState;
		const LoginWindowForCorrectVersion = currentUIVersion === "5.0" ? LoginWindowV5 : LoginWindow;

		return (
			<DomPortal
				destination={appState.app.modalContainer}
				noPortal={false}
			>
				<PopupBackdropV5 onClick={Functions.stopPropagation}>
					<OrganizationSwitchContainerStyled className="sso-switch">
						<LoginWindowForCorrectVersion
							handleClose={onClose}
							isOrganizationSwitchView={true}
							handleOrganizationSwitch={handleSwitchFromSSOToNormalLoginSuccess}
						/>
					</OrganizationSwitchContainerStyled>
				</PopupBackdropV5>
			</DomPortal>
		);
	} else {
		return <></>;
	}
});

const OrganizationSwitchContainerStyled = styled.div`
	${LoginWindowStyled} {
		background: none;
	}
`;
